/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { Observable } from 'rxjs';
import {
  AgentCredentials,
  AgentLogged,
  RolPermissions,
  Status,
  StatusTypes,
  ArchiveTimeoutOption,
  UpdateArchiveSettingsRequest,
} from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  private url: string = 'agents';

  constructor(private apiService: ApiService) {}

  public onLogin(request: AgentCredentials): Observable<AgentLogged> {
    return this.apiService.post(`${this.url}/login`, request);
  }

  public getPermissions(): Observable<RolPermissions> {
    return this.apiService.get(`${this.url}/permissions`);
  }

  public updateStatus(request: Status): Observable<any> {
    return this.apiService.patch(`${this.url}/statuses`, request);
  }

  public getStatus(): Observable<StatusTypes[]> {
    return this.apiService.get(`${this.url}/statuses`);
  }

  public getArchiveTimeoutOptions(): Observable<ArchiveTimeoutOption[]> {
    return this.apiService.get(`${this.url}/archive-timeout-options`);
  }

  public updateArchiveSettings(
    request: UpdateArchiveSettingsRequest,
  ): Observable<void> {
    return this.apiService.patch(`${this.url}/archive-settings`, request);
  }
}
